module.exports = __webpack_public_path__ + "static/media/new_front_posing.4d0443f7.png";